import { BrandConfig } from "./brand-config";
import { BRAND_REGISTRY } from "./brands";

const DEFAULT_BRAND = "rantalainen";

/**
 * Resolves the active brand from the current hostname.
 * Called synchronously in main.ts before Angular bootstraps.
 *
 * Also supports a `?brand=<id>` query param override.
 */
export function resolveBrand(): BrandConfig {
  // First, check for the 'brand' query parameter
  const params = new URLSearchParams(window.location.search);
  const brandOverride = params.get("brand");
  if (brandOverride && BRAND_REGISTRY[brandOverride]) {
    return BRAND_REGISTRY[brandOverride];
  }

  // If no query param, then:
  // Match brandId against full domain segments to avoid substring false positives
  // e.g. "connect.rantalainen.fi" -> segments ["connect", "rantalainen", "fi"]
  const segments = window.location.hostname.toLowerCase().split(".");
  for (const [brandId, brand] of Object.entries(BRAND_REGISTRY)) {
    if (segments.includes(brandId.toLowerCase())) {
      return brand;
    }
  }

  return BRAND_REGISTRY[DEFAULT_BRAND];
}
